import { ApiResponse, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

/**
 *
 */
export const SendCSATCustomerSubmissionSchema = z.object({
  caseId: z.string({ required_error: 'CSAT Question ID is required!' }).uuid(),
  csatAnswers: z.array(
    z.object({
      csatQuestionId: z.string({ required_error: 'CSAT Question ID is required!' }).uuid(),
      answer: z.string({ required_error: 'Answer is required!' }),
    })
  ),
});
export type TSendCSATCustomerSubmissionPayload = z.infer<typeof SendCSATCustomerSubmissionSchema>;
export type TSendCSATCustomerSubmissionResponse = ApiResponse<{
  message: string;
}>;

export const sendCSATCustomerSubmission = async (
  data: TSendCSATCustomerSubmissionPayload
): Promise<TSendCSATCustomerSubmissionResponse> => {
  const url = `/csat/submission/${data.caseId}`;

  const payload = {
    csatAnswers: data.csatAnswers,
  };

  return axiosInstance.post(url, payload);
};

/**
 * React Query Hooks
 */
type UseSendCSATCustomerSubmissionOptions = {
  mutationConfig?: TypedMutationConfig<typeof sendCSATCustomerSubmission>;
};

export const useSendCSATCustomerSubmission = ({ mutationConfig }: UseSendCSATCustomerSubmissionOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: sendCSATCustomerSubmission,
    ...restConfig,
  });
};
